import {
  IProjectSpaceType,
  SpaceTypeColor,
} from 'spw-redux/modules/space_types/types';
import { pick } from 'ramda';
import {
  CUSTOM_AMENITY_SPACE_CHILD,
  CUSTOM_MEETING_SPACE_CHILD,
  CUSTOM_OFFICE_TYPE,
  CUSTOM_SUBCATEGORY,
  CUSTOM_SUBCATEGORY_SPACE_TYPE_CHILD,
  CUSTOM_SUPPORT_SPACE_TYPE,
  CUSTOM_WORKSPACE_TYPE,
  PRIVATE_OFFICES_SUBCATEGORY,
  SPACE_NAME_MAP,
  WORKSTATIONS_SUBCATEGORY,
} from 'spw-constants';
import { IProjectColors } from 'spw-redux/modules/projects/types';

export const buildSpaceTypeColors = (spaceTypes: IProjectSpaceType[]) => {
  return spaceTypes.reduce((map, spaceType) => {
    return {
      ...map,
      [spaceType.id]: pick(['id', 'color', 'gradientColorIndex'], spaceType),
    };
  }, {});
};

const {
  INDIVIDUAL_WORKSPACES,
  PRIVATE_OFFICES,
  MEETING_SPACES,
  AMENITY_SPACES,
  SUPPORT_SPACES,
} = SPACE_NAME_MAP;

const defaultSpaceTypeColorIndex = {
  [INDIVIDUAL_WORKSPACES.HOTEL_DESK]: 4,
  [INDIVIDUAL_WORKSPACES.WORKSTATION]: 6,
  [CUSTOM_WORKSPACE_TYPE]: 10,
  [CUSTOM_OFFICE_TYPE]: 9,
  [CUSTOM_SUBCATEGORY_SPACE_TYPE_CHILD]: 10,
  [PRIVATE_OFFICES.PRIVATE_OFFICE]: 14,
  [PRIVATE_OFFICES.EXECUTIVE_PRIVATE_OFFICE]: 16,
  [PRIVATE_OFFICES.SHARED_PRIVATE_OFFICE]: 18,
  [MEETING_SPACES.OPEN_COLLABORATIVE_SPACE]: 0,
  [MEETING_SPACES.HUDDLE_ROOM]: 3,
  [MEETING_SPACES.MULTI_PURPOSE]: 5,
  [MEETING_SPACES.PHONE_ROOM]: 7,
  [MEETING_SPACES.SMALL_CONFERENCE_ROOM]: 9,
  [CUSTOM_MEETING_SPACE_CHILD]: 10,
  [MEETING_SPACES.TRAINING_ROOM]: 12,
  [MEETING_SPACES.MEDIUM_CONFERENCE_ROOM]: 14,
  [MEETING_SPACES.X_LARGE_CONFERENCE_ROOM]: 15,
  [MEETING_SPACES.LARGE_CONFERENCE_ROOM]: 18,
  [AMENITY_SPACES.FITNESS_ROOM]: 3,
  [AMENITY_SPACES.WELLNESS_ROOM]: 4,
  [AMENITY_SPACES.PANTRY]: 5,
  [AMENITY_SPACES.MEDITATION_ROOM]: 6,
  [AMENITY_SPACES.BREAK_ROOM]: 8,
  [CUSTOM_AMENITY_SPACE_CHILD]: 11,
  [AMENITY_SPACES.LIBRARY]: 13,
  [AMENITY_SPACES.CAFE]: 14,
  [AMENITY_SPACES.GAME_ROOM]: 15,
  [AMENITY_SPACES.MOTHERS_ROOM]: 16,
  [SUPPORT_SPACES.COAT_CLOSET]: 2,
  [SUPPORT_SPACES.RECEPTION_DESK_SEATING]: 4,
  [SUPPORT_SPACES.COPY_PRINT_ROOM]: 5,
  [SUPPORT_SPACES.STORAGE_ROOM]: 7,
  [SUPPORT_SPACES.IT_TECH_BAR]: 8,
  [SUPPORT_SPACES.FILE_CABINET]: 9,
  [SUPPORT_SPACES.JANITORIAL_CLOSET]: 10,
  [SUPPORT_SPACES.IDF]: 11,
  [CUSTOM_SUPPORT_SPACE_TYPE]: 12,
  [SUPPORT_SPACES.ADA_BATHROOM]: 13,
  [SUPPORT_SPACES.MDF]: 14,
  [SUPPORT_SPACES.STORAGE_LOCKER]: 15,
  [SUPPORT_SPACES.SATELLITE_COPY_AREA]: 16,
  [SUPPORT_SPACES.IT_STORAGE_ROOM]: 17,
};

export const buildDefaultSpaceTypeColors = (
  categorySpaceTypes: IProjectSpaceType[],
  selectedCategoryGradientColors: string[]
) => {
  return categorySpaceTypes.reduce(
    (map, projectSpaceType: IProjectSpaceType) => {
      const gradientColorIndex: number =
        defaultSpaceTypeColorIndex[projectSpaceType.spaceType.spaceType];
      return {
        ...map,
        [projectSpaceType.id]: {
          id: projectSpaceType.id,
          gradientColorIndex,
          color: selectedCategoryGradientColors[gradientColorIndex],
        } as SpaceTypeColor,
      };
    },
    {}
  );
};

export const buildCurrentProjectSubcategoryColors = (
  colors: IProjectColors
) => {
  return {
    [WORKSTATIONS_SUBCATEGORY]: {
      color: colors[WORKSTATIONS_SUBCATEGORY] as string,
      gradientColorIndex: colors.workstationsGradientColorIndex as number,
    },
    [PRIVATE_OFFICES_SUBCATEGORY]: {
      color: colors[PRIVATE_OFFICES_SUBCATEGORY] as string,
      gradientColorIndex: colors.privateOfficesGradientColorIndex as number,
    },
    [CUSTOM_SUBCATEGORY]: {
      color: colors[CUSTOM_SUBCATEGORY] as string,
      gradientColorIndex: colors.customSubcategoryGradientColorIndex as number,
    },
  };
};
